import { checkNoChosenYears } from 'portfolio3/features/pdf/utils/checkNoChosenYears';
import { checkSectionEmptiness } from 'portfolio3/features/pdf/utils/checkSectionEmptiness';
import { sortPeriods } from 'portfolio3/features/pdf/utils/sortPeriods';
import { createSelector } from 'reselect';
import { chosenYearsSelector } from 'selectors/drawers';
import { academicYearsTouchedSelector } from 'selectors/drawers/linkSharingDrawer';

import { cultureOnlineEventsYearsSelector } from './cultureOnlineEventsYearsSelector';
import { cultureVisitingsYearsSelector } from './cultureVisitingsYearsSelector';

export const cultureSectionAcademicYearsDataSelector = createSelector(
  [
    // Данные раздела культура
    cultureVisitingsYearsSelector,
    cultureOnlineEventsYearsSelector,
    // Выбранные года
    chosenYearsSelector,
    academicYearsTouchedSelector,
  ],
  (cultureVisitingsYears, cultureOnlineEventsYears, chosenYears, academicYearsTouched) => {
    const emptyDataMap = {
      offlineVisit: checkNoChosenYears(cultureVisitingsYears, chosenYears, academicYearsTouched),
      onlineVisit: checkNoChosenYears(cultureOnlineEventsYears, chosenYears, academicYearsTouched),
    };

    const periods: Set<string> = new Set([...cultureVisitingsYears, ...cultureOnlineEventsYears]);

    return {
      academicYears: sortPeriods(periods),
      emptyDataMap: {
        ...emptyDataMap,
        culture: checkSectionEmptiness(emptyDataMap),
      },
    };
  },
);
